import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import qs from 'qs'
Vue.use(Vuex)
const state = {
    accessPointsList: [],
    sourceNatDataList: [],
    allApData: [],
    ipRangesList: [],
    cpeDevicesList: [],
    oltOnuData: [],
    peeringData: [],
}

const mutations = {
    SET_AP_DATA(state, data) {
        state.accessPointsList = data;
    },
    SET_IP_RANGES_DATA(state, data) {
        state.ipRangesList = data;
    },
    SET_CPE_DEVICE_DATA(state, data) {
        state.cpeDevicesList = data;
    },
    SET_OLT_DATA(state, data) {
        state.oltOnuData = data;
    },
    SET_PEERING_DATA(state, data) {
        state.peeringData = data;
    },
    SET_ALL_AP_DATA(state, data) {
        state.allApData = data;
    },
    DELETE_ACCESS_POINTS(state, ids) {
        if (Object.keys(state.accessPointsList).length != 0 && ids.length > 0) {
            for (var i = 0; i < ids.length; i++) {
                for (var j = 0; j < state.accessPointsList.apGroups.length; j++) {
                    var groupId = state.accessPointsList.apGroups[j].ApGroup.id;
                    var index = state.accessPointsList.accessPoints[groupId].findIndex(aps => aps.AccessPoint.id == ids[i]);
                    if (index != -1) {
                        state.accessPointsList.accessPoints[groupId].splice(index, 1);
                        break;
                    }
                }
            }
        }
    },
    DELETE_FROM_ALL_APS(state, ids) {
        if (Object.keys(state.allApData).length != 0 && ids.length > 0) {
            for (var i = 0; i < ids.length; i++) {
                var index = state.allApData.message.findIndex(aps => aps.AccessPoint.id == ids[i]);
                if (index != -1) {
                    state.allApData.message.splice(index, 1);
                    break;
                }

            }
        }
    },
    MOVE_ACCESS_POINTS(state, data) {
        Vue.set(state.accessPointsList, 'accessPoints', data.accessPoints);
        Vue.set(state.accessPointsList, 'apGroups', data.apGroups);
    },
    EDIT_MAC_ADDRESS(state, data) {
        var groupId = data.apGroupId;
        var index = state.accessPointsList.accessPoints[groupId].findIndex(ap => ap.AccessPoint.id == data.apId);
        Vue.set(state.accessPointsList.accessPoints[groupId][index].AccessPoint, 'mac', data.macAddress);
    },
    EDIT_MAC_ADDRESS_FROM_ALL_APS(state, data) {
        var groupId = data.apId;
        console.log("state ",state.allApData.message);
        var index = state.allApData.message.findIndex(ap => ap.AccessPoint.id == data.apId);
        console.log("index ",index);
        Vue.set(state.allApData.message[index].AccessPoint, 'mac', data.macAddress);
    },
    EDIT_AP_NAME(state, data) {
        var groupId = data.apGroupId;
        var index = state.accessPointsList.accessPoints[groupId].findIndex(ap => ap.AccessPoint.id == data.pk);
        Vue.set(state.accessPointsList.accessPoints[groupId][index].AccessPoint, 'name', data.value);
    },
    EDIT_AP_NAME_FROM_ALL_APS(state, data) {
        var index = state.allApData.message.findIndex(ap => ap.AccessPoint.id == data.pk);
        Vue.set(state.allApData.message[index].AccessPoint, 'name', data.value);
    },
    ADD_ACCESS_POINTS(state, data) {
        var groupId = data.apDetails.AccessPoint.ap_group_id;
        if (data.type == 'add') {
            state.accessPointsList.accessPoints[groupId].push(data.apDetails);
        } else {
            var index = state.accessPointsList.accessPoints[groupId].findIndex(ap => ap.AccessPoint.id == data.apDetails.AccessPoint.id);
            state.accessPointsList.accessPoints[groupId].splice(index, 1, data.apDetails);
        }
    },
    ADD_ACCESS_POINTS_FROM_ALL_APS(state, data) {
        var groupId = data.apDetails.AccessPoint.ap_group_id;
        if (data.type == 'add') {
            state.accessPointsList.accessPoints[groupId].push(data.apDetails);
        } else {
            var index = state.allApData.message.findIndex(ap => ap.AccessPoint.id == data.apDetails.AccessPoint.id);
            state.allApData.message.splice(index, 1,data.apDetails);
        }
    },
    ADD_SOURCE_NAT_LIST(state, sourceNatData) {
        var data = sourceNatData;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {            
            state.sourceNatDataList.push(data[i]);        
          }
        }
      },
    DEACTIVATE_ACCESS_POINTS(state, data) {
        var groupId = data.AccessPoint.ap_group_id;
        var index = state.accessPointsList.accessPoints[groupId].findIndex(ap => ap.AccessPoint.id == data.AccessPoint.id);
        Vue.set(state.accessPointsList.accessPoints[groupId][index].AccessPoint, 'is_active', data.AccessPoint.is_active);
    },
    DEACTIVATE_ACCESS_POINTS_FROM_ALL_APS(state, data) {
        var groupId = data.AccessPoint.ap_group_id;
        var index = state.allApData.message.findIndex(ap => ap.AccessPoint.id == data.AccessPoint.id);
        Vue.set(state.allApData.message[index].AccessPoint, 'is_active',data.AccessPoint.is_active);
    },
    ADD_EDIT_IP_RANGES(state, data) {
        if (data.type == 'add') {
            state.ipRangesList.ranges.push(data.routerAdded);
        } else {
            var index = state.ipRangesList.ranges.findIndex(ip => ip.IpRange.id == data.routerAdded.IpRange.id);
            state.ipRangesList.ranges.splice(index, 1, data.routerAdded);
        }
    },
    DELETE_IP_RANGES(state, id) {
        if (Object.keys(state.ipRangesList).length != 0) {
            var index = state.ipRangesList.ranges.findIndex(ip => ip.IpRange.id == id);
            state.ipRangesList.ranges.splice(index, 1);
        }
    },
    ADD_CPE_DEVICE(state, data) {
        state.cpeDevicesList.cpeDevices.push(data);
    },
    EDIT_CPE_DEVICE(state, data) {
        var index = state.cpeDevicesList.cpeDevices.findIndex(cpe => cpe.CpeDevice.id == data.id);
        Vue.set(state.cpeDevicesList.cpeDevices[index], 'CpeDevice', data)
    },
    DELETE_CPE_DEVICE(state, id) {
        if (Object.keys(state.cpeDevicesList).length != 0) {
            var index = state.cpeDevicesList.cpeDevices.findIndex(cpe => cpe.CpeDevice.id == id);
            state.cpeDevicesList.cpeDevices.splice(index, 1);
        }
    },

    SET_FAILURE(state, error) {
        Nprogress.done();
        Vue.notify({
            group: 'foo',
            type: 'error',
            text: error
        });
    },
    SET_SUCCESS(state, error) {
        Nprogress.done();
        Vue.notify({
            group: 'foo',
            type: 'success',
            text: error
        });
    },
    CLEAR_ROUTERS_STATE(state) {
        state.accessPointsList = [];
        state.allApData = [];
        state.ipRangesList = [];
        state.cpeDevicesList = [];
        state.oltOnuData = [];
    }
}

const actions = {

    clearRoutersState({
        commit,
    }) {
        commit('CLEAR_ROUTERS_STATE')
    },
    importSourceNatModal({
        commit,
        dispatch
      }, postData) {
        return new Promise((resolve, reject) => {
    
          let loader = Vue.$loading.show({
            canCancel: false,
          });
          axios.post('/access_points/import_source_nat_file', postData)
            .then(response => {
              loader.hide()   
              console.log(response);  
              var data = {
                sourceNatData: response.data.newSrcNatData,                
              }
              commit('ADD_SOURCE_NAT_LIST', data);         
              resolve(response.data);
            })
            .catch(error => console.log(error));
        });
      },

    fetchAccesPointsData({
        commit,
    }) {
        Nprogress.start()
        axios.get('/access_points/index/true')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  } else {
                commit('SET_AP_DATA', res.data.message)
                  }
            })
            .catch(error => console.log(error))
    },

    fetAllApsData({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/accesspoints_data', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status == "redirect") {
                        router.push("/dashboard");
                      } else {
                    commit('SET_ALL_AP_DATA', response.data)
                    resolve(response.data);
                      }
                })
                .catch(error => console.log(error));
        });
    },

    fetchIpRangesData({
        commit,
    }) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
        axios.get('/access_points/ip_ranges/true')
            .then(res => {
                loader.hide();
                // console.log("fetchIpRangesData res: ",res);
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  }else if(res.data.status=="error" && res.data.isDatabaseAccessibleCheck=="yes"){
                    resolve(res.data);
                    
                  } else {
                commit('SET_IP_RANGES_DATA', res.data.message)
                  }
            })
            .catch(error => console.log(error))
        });
    },

    fetchCpeDeviceData({
        commit,
    }) {
        Nprogress.start()
        axios.get('/access_points/cpe_device/null/true')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  } else {
                commit('SET_CPE_DEVICE_DATA', res.data.message)
                  }
            })
            .catch(error => console.log(error))
    },

    fetchOltOnuData({
        commit,
    }, getData) {
        Nprogress.start()
        axios.get('/access_points/olt_onu/'+getData.deviceId+'/'+getData.accountId+'/'+getData.power+'/true')
            .then(res => {
                Nprogress.done()
                commit('SET_OLT_DATA', res.data.message)
            })
            .catch(error => console.log(error))
    },

    fetchPeeringData({
        commit,
    }, getData) {
        Nprogress.start()
        axios.get('/access_points/peering/'+getData.apId+'/true')
            .then(res => {
                Nprogress.done()
                commit('SET_PEERING_DATA', res.data.message)
            })
            .catch(error => console.log(error))
    },

    deleteApsSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/delete_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = response.data.apIds;
                    if (postData.type == 'index') {
                        commit('DELETE_ACCESS_POINTS', successData);
                    } else {
                        commit('DELETE_FROM_ALL_APS', successData);
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    moveApsSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/move_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('MOVE_ACCESS_POINTS', response.data);
                    var msg = response.data.genericBody + postData.groupName;
                    resolve(msg);
                })
                .catch(error => console.log(error));
        });
    },

    createApGroupSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/ap_groups/add_ap_group', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    editMacAddrSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/change_mac_address', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if(postData.type == "fromAllAps"){
                        commit('EDIT_MAC_ADDRESS_FROM_ALL_APS', postData);
                        console.log("EDIT_MAC_ADDRESS_FROM_ALL_APS");
                    } else {
                        commit('EDIT_MAC_ADDRESS', postData);
                    }
                    resolve(response.data.genericTitle);
                })
                .catch(error => console.log(error));
        });
    },

    editApNameSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/edit_ap_fields', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if(postData.type == "fromAllAps"){
                    commit('EDIT_AP_NAME_FROM_ALL_APS', postData);
                    } else {
                    commit('EDIT_AP_NAME', postData);
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    addEditAccessPointSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/add_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        type: postData.actionType,
                        apDetails: response.data.apDetails
                    }
                    if(postData.from == "fromAllAps"){
                        commit('ADD_ACCESS_POINTS_FROM_ALL_APS', successData);
                    } else{
                         commit('ADD_ACCESS_POINTS', successData);
                    }
                    resolve(response.data.genericTitle);
                })
                .catch(error => console.log(error));
        });
    },

    networkConfigSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/ap_network_config', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    deactivateApSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/deactivate_or_activate_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if(postData.type == "fromAllAps"){
                    commit('DEACTIVATE_ACCESS_POINTS_FROM_ALL_APS', response.data.apDetails);
                    } else{
                    commit('DEACTIVATE_ACCESS_POINTS', response.data.apDetails);
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    portForwardDelSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/delete_port_forward', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.genericTitle);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    sourceNatDelSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/delete_srcnat', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'Success') {
                        reject(response.data.genericTitle);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    addPortForwardSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/add_port_forward', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    addSrcNatSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/submit_Srcnet', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }                    
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    addMacBypassSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/mac_bypass', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    blockMacBypassSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/block_mac', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    removeMacBypassSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/remove_mac_bypass', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    bypassMacSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/mac_bypass', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    blockMacSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/block_mac', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    removeDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/remove_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    addDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/add_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    editDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/edit_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    restartMac({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/restart_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve('Success');
                })
                .catch(error => console.log(error));
        });
    },

    upgradeAccessPoint({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/upgrade_ap', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve('Success');
                })
                .catch(error => console.log(error));
        });
    },

    editVlanSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/create_dynamic_vlan_ip_pool', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    ipRangesSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/save_ip_range', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var data = {
                        type:postData.type,
                        routerAdded: response.data.routerAdded
                    }
                    commit('ADD_EDIT_IP_RANGES', data);
                    if(postData.type=='add') {
                        resolve(response.data.genericBody);
                    } else {
                        resolve(response.data.genericBody1);
                    }
                })
                .catch(error => console.log(error));
        });
    },

    deleteIpRangeSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/delete_range', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('DELETE_IP_RANGES', postData.fieldId)
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    addCpeDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/submit_cpe_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('ADD_CPE_DEVICE', response.data.cpeAdded);
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    editCpeDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/edit_cpe_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('EDIT_CPE_DEVICE', response.data.cpeEdited);
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    deleteCpeDeviceSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post(postData.url, qs.stringify( {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('DELETE_CPE_DEVICE', postData.id)
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    linkToUserSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/link_onu_to_user', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    unlinkUser({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/unlink_onu', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    },

    addPeeringSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/submit_peering', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    editPeeringSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/edit_peering', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data.genericBody);
                })
                .catch(error => console.log(error));
        });
    },

    deletePeeringSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/access_points/delete_peering', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.genericTitle);
                        return;
                    }
                    resolve(response.data.message);
                })
                .catch(error => console.log(error));
        });
    }

}

const getters = {
    accessPointsGetter: state => {
        return state.accessPointsList;
    },
    sourceNatDataGetter: state => {
        return state.sourceNatDataList;
    },
    allApsGetter: state => {
        return state.allApData;
    },
    ipRangesGetter: state => {
        return state.ipRangesList;
    },
    cpeDevicesGetter: state => {
        return state.cpeDevicesList;
    },
    oltOnuGetter: state => {
        return state.oltOnuData;
    },
    peeringDataGetter: state => {
        return state.peeringData;
    },

}

export default {
    state,
    mutations,
    actions,
    getters
}
